import * as styles from './themeHelpers.module.scss';

const themeClassNames = {
  dark: styles.themeDarkClassName as string,
  light: styles.themeLightClassName as string,
};

export function getThemeClassName(isDarkMode: boolean): string {
  return isDarkMode ? themeClassNames.dark : themeClassNames.light;
}

export function setUpThemeRoot(isDarkMode: boolean) {
  const targetClassName = getThemeClassName(isDarkMode);

  const classNames = Object.values(themeClassNames);
  classNames.forEach((className) => {
    document.body.classList.toggle(className, className === targetClassName);
  });

  return () => {
    classNames.forEach((className) =>
      document.body.classList.remove(className),
    );
  };
}
